// framework/common/schemas/collections/oneTimeLoginTokens.js
import { z } from "zod";

const OneTimeLoginTokenSchema = z.object({
    _id: z.string().optional(),
    token: z.string().describe("The secure, random, unique token."),
    
    // The identity to log in
    userId: z.string(),
    subscriptionId: z.string(),
    serviceCode: z.string(),
    
    // State management
    isUsed: z.boolean().default(false),
    expiresAt: z.coerce.date(),
    
    // Audit information
    createdBy: z.string().describe("Identifier of the entity that created the token (e.g., admin userId, agent name)."),
    createdAt: z.coerce.date(),
});

export default OneTimeLoginTokenSchema;